// extracted by mini-css-extract-plugin
export default {"middlePaneGrid":"IssueIndexPage-module__middlePaneGrid--hXFwX"};